'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _query = require('utilities/query');

var _compliantMembers = require('./compliant-members.html');

var _compliantMembers2 = _interopRequireDefault(_compliantMembers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _compliantMembers2.default,
  bindings: {
    companies: '<'
  },
  controller: function () {
    function CompliantMembersComponent($mdDialog, EventEmitter) {
      'ngInject';

      _classCallCheck(this, CompliantMembersComponent);

      Object.assign(this, { $mdDialog: $mdDialog, EventEmitter: EventEmitter });
    }

    _createClass(CompliantMembersComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.query = (0, _query.getQuery)();
        this.limitOptions = (0, _query.getLimitOptions)();
      }
    }]);

    return CompliantMembersComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/member-compliance/compliant-members/compliant-members.component.js